import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { cn } from '~/utils';
type ActivityListCardProps = {
  children: React.ReactNode;
  className?: string;
  /** Use `div` when this card is already inside a list item (e.g. cart `<li>`). Default `li` for direct `<ul>` children. */
  as?: 'li' | 'div';
} & Omit<React.HTMLAttributes<HTMLElement>, 'className' | 'children'>;
export function ActivityListCard(t0) {
  const $ = _c(15);
  let children;
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className,
      as: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const as = t1 === undefined ? "li" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("relative rounded-2xl border p-4", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const classNames = t2;
  if (as === "div") {
    let t3;
    if ($[7] !== children || $[8] !== classNames || $[9] !== rest) {
      t3 = <div className={classNames} {...rest}>{children}</div>;
      $[7] = children;
      $[8] = classNames;
      $[9] = rest;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  let t3;
  if ($[11] !== children || $[12] !== classNames || $[13] !== rest) {
    t3 = <li className={classNames} {...rest}>{children}</li>;
    $[11] = children;
    $[12] = classNames;
    $[13] = rest;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
export function ActivityListCardContent(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.className) {
    t0 = cn("flex gap-4", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <div className={t0}>{props.children}</div>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export function ActivityListCardImage(props) {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.alt || $[1] !== props.imageClassName || $[2] !== props.src) {
    t0 = props.src ? <Image src={props.src} alt={props.alt} fill={true} className={cn("object-cover", props.imageClassName)} /> : null;
    $[0] = props.alt;
    $[1] = props.imageClassName;
    $[2] = props.src;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const image = t0;
  if (props.href) {
    const t1 = props.href;
    const t2 = props.target;
    let t3;
    if ($[4] !== props.className) {
      t3 = cn("relative block", props.className, "transition-opacity hover:opacity-80");
      $[4] = props.className;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== image || $[7] !== props.href || $[8] !== props.target || $[9] !== t3) {
      t4 = <a href={t1} target={t2} className={t3}>{image}</a>;
      $[6] = image;
      $[7] = props.href;
      $[8] = props.target;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  let t1;
  if ($[11] !== image || $[12] !== props.className) {
    t1 = <div className={props.className}>{image}</div>;
    $[11] = image;
    $[12] = props.className;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
}
export function ActivityListCardBody(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.className) {
    t0 = cn("flex min-w-0 flex-1 flex-col items-start justify-center", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <div className={t0}>{props.children}</div>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export function ActivityListCardHeader(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.className) {
    t0 = cn("flex items-start justify-between gap-3", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <div className={t0}>{props.children}</div>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export function ActivityListCardTitle(props) {
  const $ = _c(12);
  let t0;
  if ($[0] !== props.className) {
    t0 = cn("block text-base font-bold text-primary transition-colors hover:text-orange-500", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const titleClassName = t0;
  if (props.href) {
    let t1;
    if ($[2] !== props.children || $[3] !== props.href || $[4] !== props.target || $[5] !== titleClassName) {
      t1 = <a href={props.href} target={props.target} className={titleClassName}>{props.children}</a>;
      $[2] = props.children;
      $[3] = props.href;
      $[4] = props.target;
      $[5] = titleClassName;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  let t1;
  if ($[7] !== props.className) {
    t1 = cn("text-base font-bold text-primary", props.className);
    $[7] = props.className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props.children || $[10] !== t1) {
    t2 = <p className={t1}>{props.children}</p>;
    $[9] = props.children;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}